import Vue from 'vue'
import Router from 'vue-router'
import DailyActiveUsersWeb from '@/components/daily-active-users-web'
import MonthlyActiveUsersWeb from '@/components/monthly-active-users-web'
import DailyActiveUsersApp from '@/components/daily-active-users-app'
import MonthlyActiveUsersApp from '@/components/monthly-active-users-app'
import SessionsApp from '@/components/sessions-app'
import SessionsWeb from '@/components/sessions-web'
import Engagement from '@/components/engagement'
import Fans from '@/components/fans'
import Impressions from '@/components/impressions'
import UsersReached from '@/components/users-reached'
import UsersAndFans from '@/components/users-and-fans'
import StreamSessions from '@/components/stream-sessions'
import StreamDuration from '@/components/stream-duration'
import AllSimulcastsAllAggregators from '@/components/all-simulcasts-all-aggregators'
import AllStreamsAllAggregators from '@/components/all-streams-all-aggregators'
import AllSessionStarts from '@/components/all-session-starts'
import StreamConversion from '@/components/stream-conversion'
import Overview from '@/components/overview'
import StreamsWebOnly from '@/components/streams-web-only'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/:display/streams-web-only',
      name: 'Web only streams',
      component: StreamsWebOnly
    },
    {
      path: '/:display/daily-active-users-app',
      name: 'Daily active users app',
      component: DailyActiveUsersApp
    },
    {
      path: '/:display/monthly-active-users-app',
      name: 'Monthly active users app',
      component: MonthlyActiveUsersApp
    },
    {
      path: '/:display/daily-active-users-web',
      name: 'Daily active users web',
      component: DailyActiveUsersWeb
    },
    {
      path: '/:display/monthly-active-users-web',
      name: 'Monthly active users web',
      component: MonthlyActiveUsersWeb
    },
    {
      path: '/:display/sessions-web',
      name: 'Sessions web',
      component: SessionsWeb
    },
    {
      path: '/:display/sessions-app',
      name: 'Sessions app',
      component: SessionsApp
    },
    {
      path: '/:display/engagement',
      name: 'Engagement',
      component: Engagement
    },
    {
      path: '/:display/fans',
      name: 'Fans',
      component: Fans
    },
    {
      path: '/:display/impressions',
      name: 'Impressions',
      component: Impressions
    },
    {
      path: '/:display/users-reached',
      name: 'Users reached',
      component: UsersReached
    },
    {
      path: '/:display/users-and-fans',
      name: 'Users and fans',
      component: UsersAndFans
    },
    {
      path: '/:display/stream-sessions',
      name: 'Stream sessions',
      component: StreamSessions
    },
    {
      path: '/:display/stream-duration',
      name: 'Stream duration',
      component: StreamDuration
    },
    {
      path: '/:display/all-simulcasts-all-aggregators',
      name: 'All simulcasts, all aggregators',
      component: AllSimulcastsAllAggregators
    },
    {
      path: '/:display/all-streams-all-aggregators',
      name: 'All streams, all aggregators',
      component: AllStreamsAllAggregators
    },
    {
      path: '/:display/all-session-starts',
      name: 'All session starts',
      component: AllSessionStarts
    },
    {
      path: '/:display/stream-conversion',
      name: 'Stream conversion',
      component: StreamConversion
    },
    {
      path: '/:display/overview',
      name: 'Overview',
      component: Overview
    },
    {
      path: '/:display/',
      name: 'Start without slug'
    },
    {
      path: '/:display',
      redirect: '/:display/'
    },
    {
      path: '/:display/*',
      name: 'Start with slug'
    }
  ]
})

// get page data before entering route
router.beforeEach((to, from, next) => {
  if (to.query.source === undefined) {
    to.query.source = 'app'
  }
  if (to.query.theme === undefined) {
    to.query.theme = to.params.display
  }
  next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js